import axios from 'axios'

class AxiosEx extends axios {
    static headers = (url) => axios.head(url).then(({ headers }) => headers)
}

export default AxiosEx
